(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kotoisa-lithophanes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kotoisa-lithophane-slider')) {
 class KotoisaLithophaneSlider extends HTMLElement {
  connectedCallback() {
   this.slides = Array.from(this.querySelectorAll('.kl-slide'));
   if (this.slides.length < 2) return;
   this.index = 0;
   this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   this.hovered = false;
   this.inView = true;
   this.toggle = this.querySelector('[data-toggle]');
   this.count = this.querySelector('[data-count]');
   this.abort = new AbortController();
   const options = { signal: this.abort.signal };
   this.querySelector('.kl-slider-controls').hidden = false;
   this.querySelector('[data-previous]').addEventListener('click', () => this.manual(-1), options);
   this.querySelector('[data-next]').addEventListener('click', () => this.manual(1), options);
   this.toggle.addEventListener('click', () => {
    this.paused = !this.paused;
    this.updateControls();
    this.schedule();
   }, options);
   this.addEventListener('pointerenter', (event) => {
    if (event.pointerType !== 'mouse') return;
    this.hovered = true;
    this.schedule();
   }, options);
   this.addEventListener('pointerleave', () => {
    this.hovered = false;
    this.schedule();
   }, options);
   this.addEventListener('focusin', (event) => {
    if (event.target === this.toggle) return;
    this.paused = true;
    this.updateControls();
    this.schedule();
   }, options);
   document.addEventListener('visibilitychange', () => this.schedule(), options);
   this.observer = new IntersectionObserver(([entry]) => {
    this.inView = entry.isIntersecting;
    this.schedule();
   });
   this.observer.observe(this);
   this.updateControls();
   this.warmNext();
   this.schedule();
  }
  disconnectedCallback() {
   clearTimeout(this.timer);
   this.abort?.abort();
   this.observer?.disconnect();
  }
  updateControls() {
   this.toggle.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
  }
  warmNext() {
   const image = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
   if (image) image.loading = 'eager';
  }
  manual(direction) {
   this.paused = true;
   this.updateControls();
   this.show(direction);
  }
  show(direction) {
   const next = (this.index + direction + this.slides.length) % this.slides.length;
   this.slides[this.index].hidden = true;
   this.slides[next].hidden = false;
   this.index = next;
   this.count.textContent = (next + 1) + ' / ' + this.slides.length;
   this.warmNext();
   this.schedule();
  }
  schedule() {
   clearTimeout(this.timer);
   if (this.paused || this.hovered || !this.inView || document.hidden) return;
   this.timer = setTimeout(() => this.show(1), 6000);
  }
 }
 customElements.define('kotoisa-lithophane-slider', KotoisaLithophaneSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
